import React from "react"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import * as agendaStyles from "../../styles/landing_pages/Agenda.module.css"

const Agenda = props => {
  const { content } = props

  return (
    <div id="agenda" className="container-fluid">
      <div className={`row ${agendaStyles.wrapper}`}>
        <div className="col">
          <div style={{ display: "grid", gridAutoRows: "1fr" }}>
            <div
              style={{
                gridArea: "1/1",
                position: "relative",
                placeItems: "left",
                display: "grid",
                zIndex: 2,
              }}
            >
              <div className={`row g-0`}>
                <div className={`col-12 ${agendaStyles.content}`}>
                  <div className={`row g-0`}>
                    <div className={`col-12 ${agendaStyles.wrapper}`}>
                      <h1>Agenda & Timing</h1>
                    </div>
                  </div>
                  <div className={`row g-0`}>
                    <div className={`col-12 ${agendaStyles.tableWrapper}`}>
                      <table className={`table ${agendaStyles.table}`}>
                        <colgroup>
                          <col style={{ width: "20%", textAlign: "left" }} />
                          <col style={{ width: "20%", textAlign: "left" }} />
                          <col style={{ width: "50%", textAlign: "left" }} />
                          <col style={{ width: "10%", textAlign: "center" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Webinar</th>
                            <th scope="col">Description</th>
                            <th scope="col">Register</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className={`${agendaStyles.colored}`}>
                            <th scope="row" data-label="Date">
                              <span data-label="Date">
                                Feb 24 Monday
                                <br /> 1:30 pm ET
                              </span>
                            </th>
                            <td data-label="Webinar">
                              IBM Planning Analytics in a Multi-Cloud Universe
                            </td>
                            <td data-label="Description">
                              Join us as we kick off Cubewise Innovation Week
                              2025 with several of the hottest topics of the
                              years ahead: IBM Planning Analytics as a Service,
                              IBM Planning Analytics Cloud, Getting to the
                              Cloud, and TM1 Server v12.
                              <br />
                              <br /> We will also talk with Tracy Peppy, Senior
                              Product Manager at IBM Planning Analytics on
                              Cloud, to explore how to make the right IBM
                              Planning Analytics deployment decision for your
                              organization in 2025.
                              <br />
                              <br /> #DoGoodTM1.{" "}
                            </td>
                            <td data-label="Register">
                              <a href="https://events.teams.microsoft.com/event/10b96168-3bb6-4a52-be64-c7b0b9a17ed7@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" data-label="Date">
                              <span data-label="Date">
                                Feb 25 Tuesday
                                <br /> 1:30 pm ET
                              </span>
                            </th>

                            <td data-label="Webinar">
                              Visual Excellence and Elite User Experiences with
                              IBM Planning Analytics
                            </td>
                            <td data-label="Description">
                              Join the Cubewise team as we explore how to
                              transform an IBM Planning Analytics-based
                              application into an enterprise-ready data
                              visualization platform that will make you and your
                              team the envy of every organization.
                              <br />
                              <br />​ We will also explore users’ crucial
                              differences and needs from a Business Intelligence
                              and Forecasting perspective regarding IBM Planning
                              Analytics, IBM Cognos Analytics, Microsoft Power
                              BI, and Tableau.
                              <br />
                              <br /> #DoGoodTM1
                            </td>
                            <td data-label="Register">
                              <a href="https://events.teams.microsoft.com/event/7829e74a-d812-47f5-886e-2744f24f1b51@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr className={`${agendaStyles.colored}`}>
                            <th scope="row">
                              <span data-label="Date">
                                Feb 26 Wednesday <br /> 1:30 pm ET
                              </span>
                            </th>
                            <td data-label="Webinar">
                              IBM Planning Analytics in an AI-enabled Universe
                            </td>
                            <td data-label="Description">
                              Here’s a fast-paced conversation covering IBM
                              Planning Analytics' role in an increasingly
                              AI-enabled universe. Join us as we explore
                              predictive analytics, decision optimization, AI
                              agents, and Generative AI and how these tools will
                              and, for some, are revolutionizing organizational
                              planning, budgeting, and reporting processes.​
                              <br />
                              <br />
                              Key topics we will explore:​ The role of AI Agents
                              in enhancing decision-making and automation.​ The
                              growing importance of Python and TM1py in
                              facilitating advanced analytics and AI-infused
                              planning.​
                              <br />
                              <br /> #DoGoodTM1
                            </td>
                            <td data-label="Register">
                              <a href="https://events.teams.microsoft.com/event/45a81e4e-3b2b-4e74-b43b-0b98e4dd7753@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              <span data-label="Date">
                                Feb 27 Thursday
                                <br /> 1:30 pm ET
                              </span>
                            </th>
                            <td data-label="Webinar">
                              High-tech Performance Tuning and Testing for IBM
                              Planning Analytics Applications
                            </td>
                            <td data-label="Description">
                              Performance tuning, system optimization, automated
                              testing, and error logging are critical activities
                              for every IBM Planning Analytics Administrator and
                              Developer as they look to deliver highly
                              performant, functional, and stable IBM Planning
                              Analytics Applications across the enterprise.​
                              <br />
                              <br /> Join us as we explore contemporary (v11 &
                              v12) and more advanced techniques and recommended
                              practices that Administrators and Developers
                              everywhere need to know in 2025.​
                              <br />
                              <br /> #DoGoodTM1
                            </td>
                            <td data-label="Register">
                              <a href="https://events.teams.microsoft.com/event/c601d6fa-8b42-4ce3-802c-f0f457ac9130@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr className={`${agendaStyles.colored}`}>
                            <th scope="row">
                              <span data-label="Date">
                                Feb 28 Friday
                                <br /> 1:30 pm ET
                              </span>
                            </th>
                            <td data-label="Webinar">
                              Advanced Data Integrations & Processing with IBM
                              Planning Analytics
                            </td>
                            <td data-label="Description">
                              Join us as we explore one of our favorite IBM
                              Planning Analytics topics: Highly performant and
                              scalable data integrations and processing.
                              <br />
                              <br /> We will also discuss how to balance
                              prebuilt connectors and custom TI scripts within
                              your organization’s IBM Planning Analytics
                              ecosystem.
                              <br />
                              <br /> Marius Wirtz, TM1py Product Manager, will
                              join the conversation and announce a significant
                              product update from the Cubewise Innovation Labs.
                              <br />
                              <br /> #DoGoodTM1
                            </td>
                            <td data-label="Register">
                              <a href="https://events.teams.microsoft.com/event/f704e13e-6654-4b0a-9a02-36636b0140b9@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${agendaStyles.backgroundContainmentImage}`}
              style={{
                gridArea: "1/1",
                objectFit: "cover",
                placeItems: "right",
                zIndex: 1,
              }}
              objectfit="cover"
              placeholderstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              imgstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              transformoptions={{ fit: "cover" }}
            >
              <WPImage
                holder={content}
                selector={`media-asset`}
                mode={DISPLAY_MODE.normal}
                className={`d-none d-lg-flex ${agendaStyles.backgroundImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Agenda
